import './review.css'
import React , { useState } from "react";

import {
    Container,
    Col,
    Row,
    Button,
    Table
} from "react-bootstrap";
import axios from 'axios';

import ParseBooking from '../../parse-booking';
// import { useHistory } from "react-router-dom";
import Stepper from '../stepper/stepper'
import SyncLoader from "react-spinners/SyncLoader";
import ReactGA from 'react-ga';

export default function ReviewBooking(props) {
    ReactGA.pageview(window.location.pathname + window.location.search);    
    const bookingData = props.location.state.bookingData; 
    const bookingTime = ParseBooking(bookingData)
    console.log(props.location.state)
    const [loading, setLoading] = useState(false);
    const [somethingWentWrong, setsomethingWentWrong] = useState(false);
    const [uploadSuccess, setuploadSuccess] = useState(false);
    // let history = useHistory();

    const onSubmit = async () => {
        setsomethingWentWrong(false);
        setuploadSuccess(false);
        setLoading(true);
        bookingData.time = bookingTime;
        axios.post('https://uae-dentist-backend.herokuapp.com/schedule/reserve-booking', bookingData)
        .then(function(response1){
            axios.post('https://uae-dentist-backend.herokuapp.com/mail/booking-notification', bookingData)
            .then(function(response2){
                console.log(response2)
                setuploadSuccess(true);
                setLoading(false);
            })
            axios.post('https://uae-dentist-backend.herokuapp.com/mail/booking-confirmed', bookingData)
            .then(function(response3){
                console.log(response3)
                setuploadSuccess(true);
                setLoading(false);
            })
            axios.post("https://uae-dentist-backend.herokuapp.com/schedule/remove-conflicting-unreserved-times", {start:bookingData.start, end:bookingData.end})
            .then((response4) => {
            console.log(response4)
          })
        })
        .catch(function (error) {
            setLoading(false);
            setsomethingWentWrong(true);
            console.log('Something went wrong');
            console.log(error);
        });


        // history.push({
        //   pathname: '/booking/review',
        //   state: { bookingData: data }
        // });
    }
        return (
            <Container className='mt-5'>
                <Row>
                    <Col xs={12} md={8} lg={6}>
                        <div className='my-5'>
                        <Stepper/>
            
                        </div>
                        <div className='my-5'>
                        <h1>Review Booking</h1>
                        <Table borderless >
                        <tbody>
                        <tr>
                            <td><h6>Clinic:</h6></td>
                            <td><h6>{bookingData.clinic_name}</h6></td>
                        </tr>
                        <tr>
                            <td><h6>Service:</h6></td>
                            <td><h6>{bookingData.title}</h6></td>
                        </tr>
                        <tr>
                            <td><h6>Time:</h6></td>
                            <td><h6>{bookingTime}</h6></td>
                        </tr>
                        <tr>
                            <td><h6>Name:</h6></td>
                            <td><h6>{bookingData.customer_name}</h6></td>
                        </tr>

                        <tr>
                            <td><h6>Email:</h6></td>
                            <td><h6>{bookingData.customer_email} </h6></td>
                        </tr>
                        <tr>
                            <td><h6>Phone Number:</h6></td>
                            <td><h6>+{bookingData.customer_phone}</h6></td>
                        </tr>
                        </tbody>
                        </Table>
                        </div>
                        <Button onClick={onSubmit} variant="primary" type="submit">
                            Confirm 
                        </Button>
                        <br/>
                        { somethingWentWrong && "Something went wrong with the booking"}
                        { uploadSuccess && "Your booking succeeded"}
                        <SyncLoader size={20} margin={3} color={"#123abc"} loading={loading} />
                    </Col>
                </Row>
            </Container>
        );
      }
    